// Theme: ascenscion-omega
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'ascenscion-omega',
  name: 'ASCENSION OMEGA',
  tagline: 'ASCENSION OMEGA',
  description: 'Estrutura Ascension com paleta omega indigo cosmico.',
  category: 'cosmic-scale',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#0D1020', '#18203A', '#6D28D9', '#E0E5FF'],
  familyId: 'ascension',
  variantName: 'OMEGA',
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-mono theme-ascenscion-omega'
  },
  colorVars: {
    '--accent': '#6D28D9',
    '--accent-foreground': '#0D1020',
    '--background': '#0D1020',
    '--border': '#3A4080',
    '--card': '#18203A',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#E0E5FF',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0D1020',
    '--foreground': '#E0E5FF',
    '--hold-fill': '#6D28D9',
    '--input': '#3A4080',
    '--modal-bg': '#0D1020',
    '--modal-border': '#3A4080',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#3A4080',
    '--muted-foreground': '#E0E5FF',
    '--nav-active': '#6D28D9',
    '--nav-bg': '#18203A',
    '--popover': '#18203A',
    '--popover-foreground': '#E0E5FF',
    '--primary': '#6D28D9',
    '--primary-foreground': '#0D1020',
    '--ring': '#6D28D9',
    '--secondary': '#3A4080',
    '--secondary-foreground': '#E0E5FF',
    '--streak': '#6D28D9',
    '--success': '#22c55e',
    '--success-foreground': '#0D1020',
    '--xp': '#6D28D9',
    '--xp-bg': '#18203A'
  },
  resolvedVars: {
    '--accent': '#6D28D9',
    '--accent-foreground': '#0D1020',
    '--accent-foreground-hsl': '231 42% 9%',
    '--accent-foreground-oklch': 'from #0D1020 l c h',
    '--accent-hsl': '263 70% 50%',
    '--accent-oklch': 'from #6D28D9 l c h',
    '--background': '#0D1020',
    '--background-hsl': '231 42% 9%',
    '--background-oklch': 'from #0D1020 l c h',
    '--border': '#3A4080',
    '--border-hsl': '235 38% 36%',
    '--border-oklch': 'from #3A4080 l c h',
    '--border-w': '1px',
    '--card': '#18203A',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#E0E5FF',
    '--card-foreground-hsl': '230 100% 94%',
    '--card-foreground-oklch': 'from #E0E5FF l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--card-hsl': '226 41% 16%',
    '--card-oklch': 'from #18203A l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0D1020',
    '--destructive-foreground-hsl': '231 42% 9%',
    '--destructive-foreground-oklch': 'from #0D1020 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#E0E5FF',
    '--foreground-hsl': '230 100% 94%',
    '--foreground-oklch': 'from #E0E5FF l c h',
    '--hold-fill': '#6D28D9',
    '--hold-fill-hsl': '263 70% 50%',
    '--hold-fill-oklch': 'from #6D28D9 l c h',
    '--input': '#3A4080',
    '--input-hsl': '235 38% 36%',
    '--input-oklch': 'from #3A4080 l c h',
    '--modal-bg': '#0D1020',
    '--modal-bg-hsl': '231 42% 9%',
    '--modal-bg-oklch': 'from #0D1020 l c h',
    '--modal-border': '#3A4080',
    '--modal-border-hsl': '235 38% 36%',
    '--modal-border-oklch': 'from #3A4080 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#3A4080',
    '--muted-foreground': '#E0E5FF',
    '--muted-foreground-hsl': '230 100% 94%',
    '--muted-foreground-oklch': 'from #E0E5FF l c h',
    '--muted-hsl': '235 38% 36%',
    '--muted-oklch': 'from #3A4080 l c h',
    '--nav-active': '#6D28D9',
    '--nav-active-hsl': '263 70% 50%',
    '--nav-active-oklch': 'from #6D28D9 l c h',
    '--nav-bg': '#18203A',
    '--nav-bg-hsl': '226 41% 16%',
    '--nav-bg-oklch': 'from #18203A l c h',
    '--popover': '#18203A',
    '--popover-foreground': '#E0E5FF',
    '--popover-foreground-hsl': '230 100% 94%',
    '--popover-foreground-oklch': 'from #E0E5FF l c h',
    '--popover-hsl': '226 41% 16%',
    '--popover-oklch': 'from #18203A l c h',
    '--primary': '#6D28D9',
    '--primary-foreground': '#0D1020',
    '--primary-foreground-hsl': '231 42% 9%',
    '--primary-foreground-oklch': 'from #0D1020 l c h',
    '--primary-hsl': '263 70% 50%',
    '--primary-oklch': 'from #6D28D9 l c h',
    '--radius': '12px',
    '--ring': '#6D28D9',
    '--ring-hsl': '263 70% 50%',
    '--ring-oklch': 'from #6D28D9 l c h',
    '--secondary': '#3A4080',
    '--secondary-foreground': '#E0E5FF',
    '--secondary-foreground-hsl': '230 100% 94%',
    '--secondary-foreground-oklch': 'from #E0E5FF l c h',
    '--secondary-hsl': '235 38% 36%',
    '--secondary-oklch': 'from #3A4080 l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#6D28D9',
    '--streak-hsl': '263 70% 50%',
    '--streak-oklch': 'from #6D28D9 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0D1020',
    '--success-foreground-hsl': '231 42% 9%',
    '--success-foreground-oklch': 'from #0D1020 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(263 70% 50% / 0.15)',
    '--xp': '#6D28D9',
    '--xp-bg': '#18203A',
    '--xp-bg-hsl': '226 41% 16%',
    '--xp-bg-oklch': 'from #18203A l c h',
    '--xp-hsl': '263 70% 50%',
    '--xp-oklch': 'from #6D28D9 l c h'
  }
}
